import React from 'react';
// logic
import { useHistory } from 'react-router-dom';
// icons
import { ReactComponent as NewIcon } from 'assets/icons/new.svg';
import ToolbarContainer from 'modules/emergencies/components/ui/containers/toolbarContainer';
import FlexContainer from 'modules/emergencies/components/ui/containers/flexContainer';
import { PremiumInput } from 'modules/emergencies/components/ui/inputs/customInput';
import RegularText from 'modules/emergencies/components/ui/texts/RegularText';
import ToolBarButton from 'modules/emergencies/components/ui/toolbar/toolBarButton';
// components

const CarriersListToolbar = ({ filtersData, lastUpdate }) => {
  const { internalSelectedFilters, setSearch } = filtersData;

  const history = useHistory();

  return (
    <ToolbarContainer noPaddingX>
      <FlexContainer>
        {/* search */}
        <PremiumInput
          onChange={(e) => {
            const newValue = e.target.value;
            setSearch(newValue);
          }}
          type="search"
          value={internalSelectedFilters.search}
          label="Search"
          width="280px"
        />
      </FlexContainer>
      <FlexContainer>
        {!!lastUpdate && <RegularText>Last update: {lastUpdate}</RegularText>}

        <ToolBarButton
          withBorder={true}
          onClick={() => {
            history.push('/carrier/new');
          }}
        >
          <NewIcon />
          New carrier
        </ToolBarButton>
      </FlexContainer>
    </ToolbarContainer>
  );
};

export default CarriersListToolbar;
